/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/resume" endpoint
 */
import fetch from "@lib/fetch";

import { decisioningStudioAgentsStopResumeCacheKeys } from "../decisioningStudioAgentsShared/constants";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type {
  PostDecisioningStudioAgentsAppGroupIdDsaIdResumeProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdResumeResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdResume = reactQueryMutationAdapter(
  decisioningStudioAgentsStopResumeCacheKeys,
  (
    props: PostDecisioningStudioAgentsAppGroupIdDsaIdResumeProps
  ): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdResumeResult> => {
    return fetch(
      `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/resume`,
      "POST",
      undefined,
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
